import React, { useMemo } from "react";
import { useQuery } from "react-query";

import {
  GridCard,
  GridLayout,
  GridHeaderCell,
  GridCell,
} from "./SummaryCardStyled";
import { getCameraMiniList } from "api/cameraAPI";
import {
  CameraMiniListItem,
  GetCameraMiniListResponse,
} from "api/interfaces/cameraInterface.interface";

type Props = {
  accountId: string;
};

export function SummaryCardCamera({ accountId }: Props): JSX.Element {
  const { data } = useQuery(
    ["cameraMiniList", accountId],
    () =>
      getCameraMiniList({
        accountId: accountId,
      }),
    {
      retry: 0,
      refetchOnWindowFocus: false,
      select: (res: GetCameraMiniListResponse) => res?.result ?? null,
    }
  );

  const rows: CameraMiniListItem[] = useMemo(() => {
    return data ?? [];
  }, [data]);

  if (rows.length === 0) {
    return <></>;
  }

  return (
    <GridCard>
      <GridLayout $columns="60px 60px">
        <GridHeaderCell>Type</GridHeaderCell>
        <GridHeaderCell $align="center" $noRightBorder>
          Qty
        </GridHeaderCell>

        {rows.map((row: CameraMiniListItem, idx) => {
          return (
            <React.Fragment key={`${row.type}-${idx}`}>
              <GridCell>{row.type}</GridCell>
              <GridCell $align="center" $noRightBorder>
                {row.qty}
              </GridCell>
            </React.Fragment>
          );
        })}
      </GridLayout>
    </GridCard>
  );
}
